import axios from 'axios'
import {CHEERIOS_V2_API_BASE_URL} from '@/constants/api.js'

const cheeriosV2API = axios.create({
  baseURL: CHEERIOS_V2_API_BASE_URL,
  timeout: 10000,
})

const remoteAPI = axios.create({
  baseURL: CHEERIOS_V2_API_BASE_URL + '/remote',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add request interceptor to always use fresh token
remoteAPI.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

export {cheeriosV2API, remoteAPI};